/**
 * /frontend/src/features/analytics/components/charts/ForecastLineChart.js
 */

import React from 'react';
import {
  Area,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Forecast line chart with confidence band.
 * @param {{data:any[],xKey:string,yKey:string,lowKey:string,highKey:string,height?:number}} props
 * @returns {JSX.Element}
 */
const ForecastLineChart = ({ data, xKey, yKey, lowKey, highKey, height }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <LineChart data={safeData} margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis dataKey={xKey} stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <Tooltip />
        <Area type="monotone" dataKey={highKey} stroke="transparent" fill="color-mix(in srgb, var(--trae-accent) 18%, transparent)" />
        <Area type="monotone" dataKey={lowKey} stroke="transparent" fill="var(--trae-surface)" />
        <Line type="monotone" dataKey={yKey} stroke={CHART_COLORS.accent} strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ForecastLineChart;
